<template>
	<div
		class="">
		<element-media
			:item="item"
			:status="'live'"
			v-if="item.type === 'media' || item.type === 'image' || item.type === 'video' "
		/>
		<element-zoom
			:item="item"

			:status="'live'"
			v-if="item.type === 'zoom_meeting'"
		/>
		<element-custom-page
			:item="item"

			:status="'live'"
			v-show="!item.is_hidden"
			v-if="item.type === 'custom_page'"
		/>
		<element-video-input
			:item="item"

			:status="'live'"
			v-if="item.type === 'video_input'"
		/>
		<element-composition
			:item="item"

			v-if="item.type === 'composition'"
		/>
		<element-ticker
			:item="item"
			v-if="item.type === 'ticker'"
		/>
		<element-lottie
			:item="item"

			:status="'live'"
			v-if="item.type === 'lottie'"
		/>
		<element-lower-third
			:item="item"

			:status="'live'"
			v-if="item.type === 'lower_third'"
		/>
		<element-timer
			:item="item"

			:status="'live'"
			v-if="item.type === 'timer'"
		/>
		<element-v-cam
			:item="item"

			:status="'live'"
			v-if="item.type === 'virtual_cam'"
		/>
	</div>
</template>

<script>
import ElementMedia from '@/components/ElementMedia.vue';
import ElementZoom from '@/components/ElementZoom.vue';
import ElementCustomPage from '@/components/ElementCustomPage.vue';
import ElementVideoInput from '@/components/ElementVideoInput.vue';
import ElementComposition from '@/components/ElementComposition.vue';
import ElementTicker from '@/components/ElementTicker.vue';
import ElementLottie from '@/components/ElementLottiePlayer.vue';
import ElementLowerThird from '@/components/ElementLowerThird.vue';
import ElementTimer from '@/components/ElementTimer.vue';
import ElementVCam from '@/components/ElementVCam.vue';

export default {
	data() {
		return {
			// composition error
			videoOptions: [],
			programOptions: [],
		};
	},
	name: 'StreamItemPlay',
	props: {
		item: {
			type: Object,
		},
		muted: {
			default: false,
		},
	},
	components: {
		ElementMedia,
		ElementZoom,
		ElementCustomPage,
		ElementVideoInput,
		ElementComposition,
		ElementTicker,
		ElementLottie,
		ElementLowerThird,
		ElementTimer,
		ElementVCam,
	},
	computed: {
		// style() {
		// 	const style = {};
		// 	style.position = 'absolute';
		// 	style.border = '0';
		// 	style.zIndex = this.item.layer_index;
		// 	return style;
		// },
	},
};
</script>
